<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "TaxComponent",
};
</script>

<style scoped></style>
